/*
 * Models for the context menu
 */

define(["backbone", "messaging/messenger"], function (Backbone, Messenger) {
  var ContextMenuModel = Backbone.Model.extend({
    defaults: {
      hidden: true,
    },
  });

  //request to get context menu items
  Messenger.reqres.setHandler("context:menu:items", function () {
    return new Backbone.Collection([
      new ContextMenuModel({ name: "addTopic", label: "contextMenu.addTopic" }),
    ]);
  });
});
